import { api } from 'app/config/apiConfig';
import { Invoice } from 'entities/Invoice';

export const issueContractInvoiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    issueContractInvoice: builder.mutation<Invoice, string>({
      query: (contractId) => ({
        url: `/contracts/${contractId}/issue-invoice`,
        method: 'POST',
        // body: data, for now without any params
      }),
      invalidatesTags: ['Invoices', 'Contract details'],
    }),
  }),
});

export const { useIssueContractInvoiceMutation } = issueContractInvoiceApi;
